import React, {useContext, useEffect, useRef, useState} from "react";
import {Wrapper} from "./navigation.styles";
import AgrogridBrandLogo from "../../assets/images/agrogrid-brand.png";
import {Button} from "../Button";
import {NavLink, useNavigate} from "react-router-dom";
import {ContactUsContext} from "../../providers/contactUs.provider";
import {useLocation, useParams} from "react-router";
import {IoClose, IoSearch} from "react-icons/io5";
import {LuShoppingCart} from "react-icons/lu";
import {useCart} from "../../providers/cart.provider";
import {useMediaQuery} from "../../hooks/media-query.hook";
import {theme} from "../../theme";
import {useAuth} from "../../providers/authentication.provider";
import {CustomHelper} from "../../helpers/custom-helper";
import {LiveMarketTicker} from "./live-market-ticker.component";

export const NavigationComponent = () => {
    const {closeContactModal, isOpen, openContactModal} = useContext(ContactUsContext);
    const {farm_slug} = useParams();
    const toggle = () => isOpen ? closeContactModal() : openContactModal();
    const location = useLocation();
    const navigate = useNavigate();
    const {cartItems} = useCart()
    const {isAuthenticated, user} = useAuth()
    const menuRef = useRef()
    const searchInputRef = useRef(null)

    const [searchQuery, setSearchQuery] = useState("")
    const [showSearchInput, setShowSearchInput] = useState(false)

    const isSearchPage = location.pathname.startsWith("/split-buy/search");

    useEffect(() => {
        if (isSearchPage) {
            const queryParams = new URLSearchParams(location.search);
            const query = queryParams.get('query') || "";
            setSearchQuery(query);
            setShowSearchInput(true);
        }
    }, [isSearchPage, location.pathname, location.search]);

    useEffect(() => {
        if (location.hash) {
            const element = document.querySelector(location.hash);
            if (element) {
                element.scrollIntoView({behavior: "smooth"});
            } else {
                window.scrollTo(0, 0);
            }
        }
        if (farm_slug !== undefined) {
            window.scrollTo(0, 0);
        }
    }, [farm_slug, location]);

    useEffect(() => {
        if (showSearchInput && searchInputRef.current) {
            searchInputRef.current.focus();
        }
    }, [showSearchInput]);


    useEffect(() => {
        const handleClickOutside = (event) => {
            if (isSearchPage) return;

            if (
                showSearchInput &&
                menuRef.current &&
                !menuRef.current.contains(event.target) &&
                !event.target.closest('.search-input-container')
            ) {
                setShowSearchInput(false);
                setSearchQuery("");
            }
        };

        document.addEventListener('mousedown', handleClickOutside);


        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [showSearchInput, isSearchPage]);

    const hideNavAndFooter = location.pathname.startsWith("/cart") || location.pathname.startsWith("/guest-sign-in");

    const isMobile = useMediaQuery(`(max-width: ${theme.breakpoints.md})`);
    if (isMobile && hideNavAndFooter) return null;

    const handleSearch = (e) => {
        e.preventDefault();
        if (searchQuery.trim()) {
            navigate(`/split-buy/search?query=${encodeURIComponent(searchQuery.trim())}`);
            if (!isSearchPage) {
                setSearchQuery("");
                setShowSearchInput(false);
            }
        }
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleSearch(e);
        }
    };

    const toggleSearchInput = () => {
        if (isSearchPage) {
            if (searchInputRef.current) {
                searchInputRef.current.focus();
            }
        } else {
            setShowSearchInput(!showSearchInput);
            if (showSearchInput) {
                setSearchQuery("");
            }
        }
    };

    const handleClearSearch = () => {
        if (isSearchPage) {
            setSearchQuery("");
            navigate("/split-buy");
            setShowSearchInput(false);
        } else {
            setSearchQuery("");
            if (searchInputRef.current) {
                searchInputRef.current.focus();
            }
        }
    };
    const shouldShowSearchInput = showSearchInput || isSearchPage;


    return (<Wrapper ref={menuRef} className="product-navigation">
        <LiveMarketTicker />
        <nav className="navbar">
            <div className="navbar_content">
                <a href="/split-buy" className="agrogid_brand tw-cursor-pointer">
                    <img
                        src={AgrogridBrandLogo}
                        alt="Agrogrid Brand Logo"
                        className="agrogrid-brand"
                    />
                </a>

                <div className="product-nav-links">
                    <NavLink to="/farms">Our Farms</NavLink>
                    <NavLink to="/split-buy">Split Buy</NavLink>
                    <NavLink to="/market-prices">Market Prices</NavLink>
                    <NavLink to="/blog">Blog</NavLink>
                    <NavLink to="/about-us">About Us</NavLink>
                </div>

                {shouldShowSearchInput && (
                    <div className="search-input-container" style={{
                        position: "absolute",
                        left: "50%",
                        transform: "translateX(-50%)",
                        top: "100%",
                        width: "100%",
                        maxWidth: "500px",
                        padding: "10px",
                        zIndex: 1000
                    }}>
                        <form onSubmit={handleSearch} style={{display: "flex", width: "100%", position: "relative"}}>
                            <input
                                ref={searchInputRef}
                                type="search"
                                placeholder="Search split buy deals..."
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                onKeyPress={handleKeyPress}
                                style={{
                                    flex: 1,
                                    padding: "10px 15px",
                                    paddingRight: searchQuery ? "35px" : "15px",
                                    border: "1px solid #ddd",
                                    borderRadius: "20px 0 0 20px",
                                    fontSize: "14px",
                                    outline: "none",
                                    transition: "padding-right 0.3s ease",
                                }}
                            />

                            {searchQuery && (
                                <button
                                    type="button"
                                    onClick={handleClearSearch}
                                    style={{
                                        position: "absolute",
                                        right: "100px",
                                        top: "50%",
                                        transform: "translateY(-50%)",
                                        background: "transparent",
                                        border: "none",
                                        color: "#999",
                                        fontSize: "18px",
                                        cursor: "pointer",
                                        padding: "0 5px",
                                        width: "30px",
                                        height: "30px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        borderRadius: "50%",
                                        transition: "all 0.3s"
                                    }}
                                    onMouseOver={(e) => {
                                        e.currentTarget.style.backgroundColor = "#f0f0f0";
                                        e.currentTarget.style.color = "#333";
                                    }}
                                    onMouseOut={(e) => {
                                        e.currentTarget.style.backgroundColor = "transparent";
                                        e.currentTarget.style.color = "#999";
                                    }}
                                    title="Clear search"
                                >
                                    <IoClose width={40} height={40}/>
                                </button>
                            )}

                            <button
                                type="submit"
                                style={{
                                    padding: "10px 20px",
                                    backgroundColor: "#4CAF50",
                                    color: "white",
                                    border: "none",
                                    borderRadius: "0 20px 20px 0",
                                    cursor: "pointer",
                                    transition: "background-color 0.3s"
                                }}
                                onMouseOver={(e) => e.currentTarget.style.backgroundColor = "#45a049"}
                                onMouseOut={(e) => e.currentTarget.style.backgroundColor = "#4CAF50"}
                            >
                                Search
                            </button>
                        </form>
                    </div>
                )}

                <div className="extensives_link home_nav_links">
                    <ul className="">
                        <li>
                            <button
                                onClick={toggleSearchInput}
                                className="nav_link"
                                style={{
                                    background: "none",
                                    border: "none",
                                    padding: 0,
                                    cursor: "pointer",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center"
                                }}
                            >
                                <IoSearch />
                            </button>
                        </li>
                        <li className={"position-relative"}>
                            <NavLink onClick={(e) => {
                                e.preventDefault();
                                window.location.pathname = "/cart";
                            }}
                                     className={`nav_link`}
                                     to="/cart">
                                <LuShoppingCart/>
                                <span></span>
                                <div className="anchor-tag">{cartItems?.length ?? 0}</div>
                            </NavLink>
                        </li>
                        <li>
                            <NavLink className={`nav_link`} to="/settings">
                                {(isAuthenticated) ? <div className="avatar tw-size-7">
                                    <span
                                        className="font-medium">{CustomHelper.getUserInitials(user?.firstname, user?.lastname)}</span>
                                </div> : <svg viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M3.66675 17.7214C3.66675 16.7489 4.05306 15.8163 4.74069 15.1286C5.42832 14.441 6.36095 14.0547 7.33341 14.0547H14.6667C15.6392 14.0547 16.5718 14.441 17.2595 15.1286C17.9471 15.8163 18.3334 16.7489 18.3334 17.7214C18.3334 18.2076 18.1403 18.6739 17.7964 19.0177C17.4526 19.3615 16.9863 19.5547 16.5001 19.5547H5.50008C5.01385 19.5547 4.54754 19.3615 4.20372 19.0177C3.8599 18.6739 3.66675 18.2076 3.66675 17.7214Z"
                                        stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
                                    <path
                                        d="M11.0002 9.77865C13.0252 9.77865 14.6668 8.13702 14.6668 6.11198C14.6668 4.08694 13.0252 2.44531 11.0002 2.44531C8.97512 2.44531 7.3335 4.08694 7.3335 6.11198C7.3335 8.13702 8.97512 9.77865 11.0002 9.77865Z"
                                        stroke="currentColor" strokeWidth="2"/>
                                </svg>}
                            </NavLink>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
        <div className="support-menu">
        <Button onClick={toggle} className="support">
            <svg viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.625 13.5C4.43153 13.5 3.28693 13.9741 2.44302 14.818C1.59911 15.6619 1.125 16.8065 1.125 18V22.5C1.125 23.6935 1.59911 24.8381 2.44302 25.682C3.28693 26.5259 4.43153 27 5.625 27H6.75C7.04837 27 7.33452 26.8815 7.5455 26.6705C7.75647 26.4595 7.875 26.1734 7.875 25.875V14.625C7.875 14.3266 7.75647 14.0405 7.5455 13.8295C7.33452 13.6185 7.04837 13.5 6.75 13.5H5.625ZM5.625 13.5C5.625 10.2179 6.92879 7.07032 9.24955 4.74955C11.5703 2.42879 14.7179 1.125 18 1.125C21.2821 1.125 24.4297 2.42879 26.7504 4.74955C29.0712 7.07032 30.375 10.2179 30.375 13.5M30.375 27H29.25C28.9516 27 28.6655 26.8815 28.4545 26.6705C28.2435 26.4595 28.125 26.1734 28.125 25.875V14.625C28.125 14.3266 28.2435 14.0405 28.4545 13.8295C28.6655 13.6185 28.9516 13.5 29.25 13.5H30.375M30.375 27C31.5685 27 32.7131 26.5259 33.557 25.682C34.4009 24.8381 34.875 23.6935 34.875 22.5V18C34.875 16.8065 34.4009 15.6619 33.557 14.818C32.7131 13.9741 31.5685 13.5 30.375 13.5M30.375 27V28.125C30.375 29.3185 29.9009 30.4631 29.057 31.307C28.2131 32.1509 27.0685 32.625 25.875 32.625H22.5"
                    stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                <path
                    d="M13.5 12.3749C13.5 11.34 13.8568 10.3367 14.5101 9.53407C15.1635 8.73145 16.0736 8.17857 17.087 7.9686C18.1004 7.75862 19.1552 7.90438 20.0737 8.38131C20.9922 8.85824 21.7183 9.6372 22.1295 10.5869C22.4565 11.3444 22.5705 12.1769 22.4565 12.9944C22.3432 13.8114 22.0074 14.5816 21.486 15.2207C20.9646 15.8598 20.2776 16.3433 19.5 16.6184C19.0611 16.7736 18.6812 17.0611 18.4125 17.4412C18.1439 17.8213 17.9998 18.2754 18 18.7409V19.1249M20.25 34.8749H18C17.4033 34.8749 16.831 34.6379 16.409 34.2159C15.9871 33.794 15.75 33.2217 15.75 32.6249C15.75 32.0282 15.9871 31.4559 16.409 31.0339C16.831 30.612 17.4033 30.3749 18 30.3749H20.25C20.8467 30.3749 21.419 30.612 21.841 31.0339C22.2629 31.4559 22.5 32.0282 22.5 32.6249C22.5 33.2217 22.2629 33.794 21.841 34.2159C21.419 34.6379 20.8467 34.8749 20.25 34.8749Z"
                    stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                <path
                    d="M18 24.75C17.8508 24.75 17.7077 24.6907 17.6023 24.5852C17.4968 24.4798 17.4375 24.3367 17.4375 24.1875C17.4375 24.0383 17.4968 23.8952 17.6023 23.7898C17.7077 23.6843 17.8508 23.625 18 23.625M18 24.75C18.1492 24.75 18.2923 24.6907 18.3977 24.5852C18.5032 24.4798 18.5625 24.3367 18.5625 24.1875C18.5625 24.0383 18.5032 23.8952 18.3977 23.7898C18.2923 23.6843 18.1492 23.625 18 23.625"
                    stroke="white" strokeWidth="1.5"/>
            </svg>
        </Button>
        </div>
    </Wrapper>);
};
